import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadosActivacionInstallOTEnumChoice,
  useCheckPermissions,
  useLoaders,
} from '@/shared';
import { useGetOrdenTrabajo } from '@/shared/actions/erp';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { SaveActivacionCambioPuertoInstallOT } from '../../../shared/components';
import { cambiosPendientesOTActivacionUrl } from '../../tables';

export type ActivacionCambioPuertoPedingPageProps = {};

const ActivacionCambioPuertoPedingPage: React.FC<
  ActivacionCambioPuertoPedingPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_ordentrabajo);

  const setAlert = useUiStore(s => s.setAlert);

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOrdenTrabajo(id!);
  useLoaders(isLoading || isRefetching);

  ///* effects ----------------
  // check state
  useEffect(() => {
    if (isLoading || isRefetching) return;

    if (
      !!data &&
      data?.data?.estado_activacion !==
        EstadosActivacionInstallOTEnumChoice.PENDIENTE_CAMBIO_PUERTO
    ) {
      setAlert(
        true,
        'La orden de trabajo no tiene el estado correcto',
        AlertSeverityEnum.error
      );
    }
  }, [data, isLoading, isRefetching]);

  if (isLoading) return null;
  if (!data?.data?.id_orden_trabajo)
    return <Navigate to={cambiosPendientesOTActivacionUrl} />;

  return (
    <SaveActivacionCambioPuertoInstallOT
      titlePage="Solicitud de Cambio de Puerto"
      ordenTrabajo={data?.data!}
    />
  );
};

export default ActivacionCambioPuertoPedingPage;
